import Admin from "../Admin";
import React from "react";
import CardAdminUserList from "../../../Component/Card/Admin/User/CardAdminUserList";
import PageHeader from "../../../Component/PageHeader";
import Menu from "../../../Component/Menu";
import MUIButton from "@mui/material/Button";
import MUIMenuItem from "@mui/material/MenuItem";
import MUIListItemIcon from "@mui/material/ListItemIcon";
import MUIAddIcon from "@mui/icons-material/Add";
import MUIVisibilityIcon from "@mui/icons-material/Visibility";
import MUIVisibilityOffIcon from "@mui/icons-material/VisibilityOff";

export default class AdminUserList extends Admin {
  constructor(props) {
    super(props);

    this.state = {
      ...this.state,
      showInactive: false,
    };
  }

  /**
   * Render the content.
   * @returns {JSX.Element} The user list card.
   */
  renderContent() {
    return <CardAdminUserList showInactive={this.state.showInactive} />;
  }

  /**
   * Render the header.
   * @returns {JSX.Element} The user list page header.
   */
  renderHeader() {
    const handleClickCreate = () => {
      this.props.history.push({
        pathname: "/admin/user",
      });
    };

    const handleClickInactive = () => {
      this.setState({
        showInactive: !this.state.showInactive,
      });
    };

    const menuItems = [
      <MUIMenuItem onClick={handleClickInactive}>
        <MUIListItemIcon>
          {this.state.showInactive ? (
            <MUIVisibilityOffIcon fontSize="small" />
          ) : (
            <MUIVisibilityIcon fontSize="small" />
          )}
        </MUIListItemIcon>
        {this.state.showInactive ? "Hide Inactive" : "Show Inactive"}
      </MUIMenuItem>,
    ];

    const buttons = [
      <MUIButton
        component="label"
        variant="contained"
        startIcon={<MUIAddIcon />}
        onClick={handleClickCreate}
      >
        Create New
      </MUIButton>,
      <Menu menuItems={menuItems} />,
    ];

    return <PageHeader title="Users" buttons={buttons} />;
  }
}
